<template>
  <div id="tab">
    <a data-toggle="collapse" :href="'#' + index" @click="getCodFaqGrupo">
      <div class="card-header" :class="{ subtab: subtab }">
        <h5 class="mb-0">
          <i class="fa fa-chevron-right"></i>
          {{ titulo }}
        </h5>
      </div>
    </a>
    <div :id="index" class :class="['collapse ', { in: exibirConteudo }]">
      <div class="card-block" :class="{ subtab: subtab }">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="conteudo"></span>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: {
    index: {
      type: String,
      default: "1",
    },
    subtab: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: "Titulo default tab",
    },
    codFaqGrupo: {
      type: Number,
      default: 0,
    },
    codFaqPergunta: {
      type: Number,
      default: 0,
    },
    conteudo: {
      type: String,
      default:
        "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.",
    },
    exibirConteudo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    getCodFaqGrupo() {
      // FAZENDO O ROTEAMENTE (QUE NORMALMENTE É FEITO NO ROUTER-LINK)
      this.$router.push({
        name: "Atendimento",
        query: {
          faqbusca: this.$route.query.faqbusca,
          grupo:
            this.codFaqGrupo > 0 ? this.codFaqGrupo : this.$route.query.grupo,
          pergunta:
            this.codFaqPergunta > 0
              ? this.codFaqPergunta
              : this.$route.query.pergunta,
        },
      });

      this.$emit("getCodFaqGrupo", this.codFaqGrupo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.card-header {
  background: var(--brand-primary, $brand-primary);
  color: #fff;
  padding: 5px 15px 12px 20px;
  margin-bottom: 10px;
  border-radius: 6px;
  border-bottom: 03px solid var(--brand-accent, $brand-accent);

  h5 {
    font-weight: bold;

    i {
      margin-right: 8px;
      color: $brand-info;
    }
  }
}

.card-block {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 15px;
  padding-top: 13px;
  margin-top: -10px;
  border: 01px solid #ddd;
  border-top: none;
  margin-bottom: 15px;
}

.card-header.subtab {
  background: transparent !important;
  border: none;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;

  h5 {
    font-weight: bold;
    border-bottom: 02px dashed #ddd;
    padding-bottom: 11px;
    font-size: 0.9em;
    color: #666;

    i {
      color: #aaa !important;
    }
  }
}

.card-block.subtab {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 25px;
  padding-top: 5px;
  border: 00px solid #ddd;
}
</style>
